export default __webpack_public_path__ + "static/media/income-icon.a4dbb7a7.svg";